export default __webpack_public_path__ + "static/media/default-profile-img.120c5266.png";